export const SkipToContent = ({ targetId = "main-content" }) => (
  <a
    href={`#${targetId}`}
    className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:bg-white focus:text-gray-900 focus:px-4 focus:py-2 focus:rounded-md focus:shadow-lg focus:z-50"
  >
    Skip to main content
  </a>
);

export default SkipToContent;
